import React, { useState } from 'react';
import CommonModal from '@components/common/CommonModal';
import Button from '@components/common/Button';
import dayjs from 'dayjs';
import {deathNotificationForm, deathNotificationFormState} from './DeathNotificationConstants'
import CommonFormFields from '@pages/Forms/CommonFormFields';
import { postDataJSON } from '../../../../services/CommonApiService';
import endpoints from '@config/endpoints';
import { toast } from 'react-toastify';
import { areDatesSame, desiredFormatDate, formateDateToTimeStamp } from '@utils/commonUtils';
import { buttonNames } from '@constants/appConstants';
import {messages} from './DeathNotificationConstants'
import './DeathNotificationForm.css'
interface DeathNotificationFormModalProps {
    setShowDeathNotificationForm:any
    showModal: boolean;
    beneficiary: any;
    setShowDeathNotification:any;
    setDisabledDeathNotification:any;
  }
const DeathNotificationFormModal: React.FC<DeathNotificationFormModalProps> = ({ setShowDeathNotificationForm, showModal, beneficiary, setShowDeathNotification, setDisabledDeathNotification}) => {
    const [formData, setFormData] = useState<any>(deathNotificationForm);
    const [deathNotificationFormStates, setDeathNotificationFormStates] = useState<any>(deathNotificationFormState);
   
    const handleChange = (value: any, key: string, id: any, option: any, code: any, changedData: any) => {
        setDeathNotificationFormStates((prevState: any) => {
    
            if (key === 'comment') {
                const wordCount = value.trim().split(/\s+/).length; 
                const isError = wordCount > 100;
                const errorMessage = isError ?  messages.commentErrorMessage: '';
    
                return {
                    ...prevState,
                    [key]: {
                        ...prevState[key],
                        value: value,
                        isError: isError,
                        message: errorMessage,
                    },
                };
            } else if(key ==='dateOfDeath' ){
               if(value){
                 if(areDatesSame(dayjs(),value, 'days')) {
                    setFormData((prevState: any) => ({
                      ...prevState,
                      timeOfDeath: {
                        ...prevState.timeOfDeath,
                          '#maxTime': dayjs(),
                          '#isCurrentTime': true,
                      },
                    }));
                  } else {
                    setFormData((prevState: any) => ({
                      ...prevState,
                      timeOfDeath: {
                        ...prevState.timeOfDeath,
                          '#maxTime': '',
                          '#isCurrentTime': false,
                      },
                    }));
                  }
                    return {
                        ...prevState,
                        [key]: {
                            ...prevState[key],
                            value: value,
                            id: option,
                            code: code,
                            changedData: changedData,
                        },
                    };
                }else{
                    return {
                        ...prevState,
                        [key]: {
                            ...prevState[key],
                            value: value,
                            id: option,
                            code: code,
                            changedData: changedData,
                        },
                        timeOfDeath:{
                            ...prevState.timeOfDeath,
                            value:'',
                            id:'',
                            code:'',
                        }
                    };
                  }
            }else{
                return {
                    ...prevState,
                    [key]: {
                        ...prevState[key],
                        value: value,
                        id: option,
                        code: code,
                        changedData: changedData,
                    },
                };
            }
        });
    };
    const resetFormState = () => {
        setDeathNotificationFormStates({
            dateOfDeath: { isError: false, message: '', isDisable: false, value: '' },
            timeOfDeath: { isError: false, message: '', isDisable: false, value: '' },
            comment: { isError: false, message: '', isDisable: false, value: '' },
        });
    }
    const handleCloseModal: any = () => {
        setShowDeathNotificationForm(false);
        setShowDeathNotification(false)
        resetFormState()
    }

    const handleBackModal = () => {
        setShowDeathNotificationForm(false);
        resetFormState()
    }
    const handleSubmit = async () => {
        try {
            const userId = localStorage.getItem('userId');   
            const healthProviderId = beneficiary?.healthprovider_id?.[0];
            const date = deathNotificationFormStates.dateOfDeath.value;
            const time = deathNotificationFormStates.timeOfDeath.value;

            const payload = {
                benefId: beneficiary.benef_id,
                senderId: userId,
                receiverId: healthProviderId,
                deathDate:formateDateToTimeStamp(date,time),
                comment: deathNotificationFormStates.comment.value,
            };
            if (!healthProviderId) {
                toast.error("Beneficiary is not tagged with health provider", {
                    position: 'top-center',
                });
                setShowDeathNotificationForm(false);
                setShowDeathNotification(false);
                return;
            }
            // Send the death notification
            const response = await postDataJSON(endpoints.sendDeathNotification, payload);
            
            // Update UI and notify success
            setShowDeathNotificationForm(false);
            setShowDeathNotification(false);
            setDisabledDeathNotification(true)
            toast.success(messages.successMessage, {
                position: 'top-center',
            });
        } catch (error:any) {
            // Handle errors gracefully
            setShowDeathNotificationForm(false);
            setShowDeathNotification(false);
            toast.error(error?.message || messages.errorMessage, {
                position: 'top-center',
            });
        }
        finally{
            resetFormState()
        }
    };

    return (
        <CommonModal
            show={showModal}
            handleClose={handleCloseModal}
            handleCustomBackButton={handleBackModal}
            conditionalClass="modal_component dynamic_form_field death-notify-form-modal"
            showCustomHeader={true}
            title=""
            size="md"
            footer={
                <div className='death-notify-form-modal-btn-container'>
                    <Button
                        onClick={handleSubmit}
                        id=""
                        buttonName={buttonNames.submit}
                        colorType={'primary'}
                        disabled={!deathNotificationFormStates.dateOfDeath.value || 
                            !deathNotificationFormStates.timeOfDeath.value || 
                            deathNotificationFormStates.dateOfDeath.isError || 
                            deathNotificationFormStates.comment.isError}
                    />
                </div>
            }
        >
            <div className='death-notify-form-modal-body'>
                <div className='header-text'>Death Details</div>
                <div className='benf-name'>{beneficiary?.benf_name}</div>
                <CommonFormFields
                    formData={formData}
                    formState={deathNotificationFormStates}
                    handleFormChange={handleChange}
                />
               </div>
        </CommonModal>
    );
};

export default DeathNotificationFormModal;